<template>
  <main class="main-content" id="topDom">
    <section class="section">
      <ul class="breadcrumb">
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li">
          <span class="breadcrumb__text"> {{ $t("i18n.headerMain.presys") }}</span>
        </li>
      </ul>

      <div class="banner" style="cursor: pointer;" :style="{height: (isMobile() ? (windowHeight - 110) + 'px !important' : '61rem')}">
        <img class="mobileBg" v-if="isMobile()" :src="imageSrc" />
        <div class="banner__content container-fluid" v-if="!isMobile()">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ $t("i18n.PRESYSTitle") }}</h1>
            </div>
          </div>
        </div>
        <div class="banner__bg" v-if="!isMobile()">
          <img :src="imgUrl" />
        </div>
      </div>

    </section>

    <section class="section">
      <div class="container-fluid">
        <div class="row mt-6 mt-md-12">
          <div class="col-12 col-md-3 mb-2 mb-md-3 pdcs" v-for="(item,index) of $t('i18n.presysHomeList')"  v-show="!item.hidden">
            <router-link :to="{ name: item.path, params: { form: item } }"  class="product">
              <div class="product__image">
                <img :src="item.img" />
              </div>
              <h3 class="product__title" v-html="item.title"></h3>
            </router-link>
          </div>
        </div>

        <div class="row mt-4 mt-md-2">
          <div class="col-12" style="width: 50%;cursor: pointer !important; ">
            <div v-if="!isMobile()" class="white-box__links" :class="{ 'mar-left-auto': !showBtn }">
              <a class="white-box__link">
                <div class="white-box__link-text" v-if="!showBtn" @click="showNews()">
                  {{ $t("i18n.seeMore") }}
                </div>
                <div class="white-box__link-text" v-if="showBtn" @click="goTop">
                  {{ $t("i18n.backTop") }}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "Presys",
  data() {
    return {
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      showBtn: false,
      imgUrl: this.isMobile() ? require("../assets/imgs/5-nei.png") : require("../assets/imgs/5-nei.png"),
    }
  },
  // created() {
  //   this.goTop();
  // },
  mounted () {
    if(this.isMobile()) {
      this.$t('i18n.presysHomeList').forEach(item => {
        item.hidden = false
      });
    }
    this.goTop();
  },
  computed: {
    imageSrc() {
      // 从i18n获取baseUrl，并拼接图片名称
      return this.$t('i18n.bannerBg4');
    }
  },
  methods: {
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    showNews() {
      this.$t('i18n.presysHomeList').forEach(item => {
        item.hidden = false
      });
      this.showBtn = true
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    }
  },
}
</script>

<style scoped>

.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #e3e3e3;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #FFFFFF;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner {
  position: relative;
  width: 100%;
  height: 61rem;
  align-items: center;
  display: flex;
  background-image: url(../assets/imgs/di-1.png);
  background-size: cover; /* 保证背景图片覆盖元素并且不变形 */
  background-position: center; /* 将背景图片居中显示 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  padding: 10rem 0 0 0;
  flex-direction: column;
}
.banner__bg {
  /* position: absolute;
  width: 100%;
  height: 61rem; */
  position: absolute;
  bottom: 0;
  margin-top: 1rem;
}
.banner__bg {
  z-index: 1;
}
.banner__bg img {
  /* max-width: 100%; */

  display: block;
  width: 100%;
  /* height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%; */
}

.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-weight: 500;
  font-size: 4rem;
  color: #fff;
  letter-spacing: -.084rem;
  line-height: 6rem;
  margin-bottom: 30rem;
}
.product {
  cursor: pointer;
}
.product:hover .product__title{
  color: #990099;
}
.product__image {
  border: 1px solid lightgray;
  height: 27rem;
  padding: 4rem;
  margin-bottom: 2rem;
  overflow: hidden;
  border-radius: .4rem;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  transition: all .2s ease-in-out;
}
.product__image:hover {
  background-image: url("../assets/imgs/btnBackground.png") ;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.product__image img {
  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
  transition-duration: .45s;
  transition-timing-function: cubic-bezier(0,-.24,0,.51);
}
.product__title {
  line-height: 2.4rem;
  display: block;
  padding: 0 1rem;
  font-weight: 550;
  font-size: 1.6rem;
  color: #000;
  letter-spacing: -.02rem;
  text-align: center;
}

.pagination-item-hidden {
  transition: all .2s ease-in-out;
  opacity: 0;
  visibility: hidden;
}
.pdcs {
  margin-right: 10rem;
}

.white-box__links {
  position: relative;
  z-index: 2;
  background: #fff;
  border: 0.1rem solid #e6e6e6;
  display: flex;
  min-height: 5rem;
  max-width: 15rem;
  overflow: hidden;
  border-radius: 2rem;
  margin-bottom: 5rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.05);
}
.mar-left-auto {
  margin-left: auto;
}
.white-box__link {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-right: 0.1rem solid #e6e6e6;
  transition: all .2s ease-in-out;
}

 .white-box__link-text {
   text-align: center;
  font-size: 2rem;
  color: #602177;
  letter-spacing: -.015rem;
  line-height: 3.2rem;
  position: relative;
  margin: 0;
  transition: all .2s ease-in-out;
}

@media (max-width: 768px) {
  .breadcrumb {
    left: 2rem;
  }
  .breadcrumb__link {
    font-size: 14px;
  }
  .banner__bg{
    margin: 0;
  }
  .banner {
    /* margin-top: -110px; */
    padding-top: 0rem;
    width: 100%;
    background-image: none !important;
    overflow:hidden;
  }
  .mobileBg {
    display: block;
    width: 100%;
    height: auto;
  } 
}
</style>



// WEBPACK FOOTER //
// src/view/presys.vue